import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { IxellAPIService, IBreakdownFileV1, IIBreakdownFileV1, Roles, BreakdownInterval, CountryScaleStats, Stats, IScaleAssistance, IAppelV1, IScaleVersion, IAssistanceV1 } from 'src/app/tools/api.service'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { Utils } from 'src/app/tools/utils';
import { Constants } from 'src/app/entities/Constants';
import { HeaderService } from 'src/app/tools/header.service';
import { StorageService } from '../../tools/storage.service';

const moment = _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MM/YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-breakdownfile',
    templateUrl: './breakdownfile.component.html',
    styleUrls: ['./breakdownfile.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class BreakdownFileComponent implements OnInit, OnDestroy {

    Form = new UntypedFormGroup({
        Country: new UntypedFormControl('', [Validators.required]),
        PostalCode: new UntypedFormControl(''),
        SocialReason: new UntypedFormControl(''),
        CTC: new UntypedFormControl(''),
        DateStart: new UntypedFormControl(''),
        DateEnd: new UntypedFormControl('')
    });

    role: Roles;
    Utils = Utils;
    displayedAdminLacour = ["nameFile", "dateFile", "readFile", "update", "delete"];
    displayedIxell = ["nameFile", "dateFile", "readFile"];
    displayedColumnsBDDLocal = ["country"];
    displayedColumnsBDDInternet = ["country"];
    displayedColumnsSpectro = ["country"];
    displayedColumnsSpectroWinIxell = ["country"];
    displayedColumnsDisconnectedScales = ["Nom_RS", "Adresse1", "Adresse2", "Code Postal", "Ville", "Pays", "Numserie", "Dateinstallation", "Fincontrat", "Bdd Locale", "Bdd Internet", "Spectro"];
    displayedColumnsHorsContratScales = ["Nom_RS", "Adresse1", "Adresse2", "Code Postal", "Ville", "Pays"];
    displayedColumnsAssistance = ["RS", "Adresse1", "Adresse2", "Code Postale", "Ville", "Pays", "CTC"];
    displayedColumnsAssistanceDos = ["N°Dossier", "creation", "RS", "Adresse1", "Adresse2", "Code Postale", "Ville", "Pays", "CTC"];
    displayedColumnAssistanceInfo = ["creation", "priseEnCharge", "duree", "reponse", "interlocuteur"];
    displayedColumnsAssistancePlus = ["cloture", "qualif", "S/N balance", "question", "dureeTotal"];
    versionsLocal: string[] = [];
    versionsInternet: string[] = [];
    versionsSpectro: string[] = [];
    versionsSpectroWinIxell: string[] = [];
    versionsSpectroIxellTech: string[] = [];
    displayedColumns: string[];
    displayModalAddFile: boolean = false;
    displayModalEditFile: boolean = false;
    displayModalDeleteFile: boolean = false;
    selectedFile: File;
    datenow: Date = new Date;
    datemin: Date = new Date(2018, 12, 31);
    idSuppr: number;
    sortDefault: Sort;
    breakdownInterval: BreakdownInterval = new BreakdownInterval();
    bddLocal: boolean = false;
    bddInternet: boolean = false;
    spectro: boolean = false;
    localOpen: boolean = false;
    internetOpen: boolean = false;
    spectroOpen: boolean = false;
    assistanceDos: boolean = false;
    countries: any;
    country: string;
    startdate = new UntypedFormControl({ value: moment().set({ 'date': 1, 'hour': 0, 'minute': 0, 'second': 0 }).subtract(1, 'year'), disabled: true });
    enddate = new UntypedFormControl({ value: moment().set({ 'date': 2, 'hour': 0, 'minute': 0, 'second': 0 }), disabled: true });
    date = new UntypedFormControl({ value: moment(), disabled: true });
    dureeAppelMoy: string;
    nbDossier: number;
    min30: number = 0;
    min1: number = 0;
    min2: number = 0;
    plus2: number = 0;
    statsDateDeb: string;
    statsDateFin: string;
    //changedate = new FormControl({ value: moment(), disabled: true });
    isLoading: boolean = false;

    scalesVersion: any[] = [];

    // Objet
    allBreakdownFile: IBreakdownFileV1[] = [];
    filterBreakdownFile: IBreakdownFileV1[] = [];
    BreakdownFile: IBreakdownFileV1 = new IBreakdownFileV1();
    breakdownFileSource: MatTableDataSource<IBreakdownFileV1> = new MatTableDataSource<IBreakdownFileV1>();
    BddLocalSource: MatTableDataSource<CountryScaleStats> = new MatTableDataSource<CountryScaleStats>();
    ScalesDisconnectedSource: MatTableDataSource<IScaleVersion> = new MatTableDataSource<IScaleVersion>();
    ScalesDisconnectedTempSource: MatTableDataSource<IScaleVersion> = new MatTableDataSource<IScaleVersion>();
    ScalesHorsContratSource: MatTableDataSource<IScaleVersion> = new MatTableDataSource<IScaleVersion>();
    ScalesConnectedSource: MatTableDataSource<IScaleVersion> = new MatTableDataSource<IScaleVersion>();
    AssistanceSource: MatTableDataSource<IScaleAssistance> = new MatTableDataSource<IScaleAssistance>();
    AssistanceDosSource: MatTableDataSource<IScaleAssistance> = new MatTableDataSource<IScaleAssistance>();
    AssistanceInfoSource: MatTableDataSource<IAppelV1> = new MatTableDataSource<IAppelV1>();

    sendScales: CountryScaleStats[] = [];
    dateImportationVersion: string;
    disconnectedScales: IScaleVersion[] = [];
    disconnectedTempScales: IScaleVersion[] = [];
    horsContratScales: IScaleVersion[] = [];
    connectedScales: IScaleVersion[] = [];
    sendScalesAssistance: IScaleAssistance[] = [];
    AllsendScalesAssistance: IScaleAssistance[] = [];
    dateImportationAssistance: string;
    currentAssistance: IScaleAssistance;
    currentAssistanceTotalCallTime: number = 0;
    currentAssistanceTotalCallTimeCalc: string;
    currentRS: string;
    currentTabGroup: number = 0;

    // Sub
    private BreakdownFileSub: any;
    private filteredBreakdownFilesSub: any;
    private editBreakdownFileSub: any;
    private deleteBreakdownFileSub: any;
    private addBreakdownFileSub: any;
    private scaleVersionSub: any;
    private scaleVersionAssistanceSub: any;
    private getStatsSub: any;
    private roleSub: any;
    private exportSub: any;
    private exportConnectSub: any;
    private exportNonConnectSub: any;
    private exportNonConnectTempSub: any;
    private getDateImportSub: any;
    private exportAssistSub: any;
    private disconnectedScaleVersionSub: any;
    private disconnectedTempScaleVersionSub: any;
    private ConnectedScaleVersionSub: any;
    private GetHorsContratSub: any;

    constructor(private headerService: HeaderService, private api: IxellAPIService, private storage: StorageService) { }

    ngOnInit() {
        this.countries = Utils.countries();
        this.headerService.changeCanBack(true);
        //this.headerService.changeTitle("Monitoring");
        this.headerService.changeTitle("common.monitoring");
        this.headerService.changeLogo("");
        this.sortDefault = { active: "dateFileEdit", direction: "desc" };
        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
        this.breakdownFileSource = new MatTableDataSource<IBreakdownFileV1>();
        this.breakdownInterval.start = this.startdate.value;
        this.breakdownInterval.end = this.enddate.value;
        this.filteredBreakdownFilesSub = this.api.filteredBreakdownFiles(this.breakdownInterval).subscribe(data => {

            console.log(data);

            if (data != null) {
                this.filterBreakdownFile = [];
                this.allBreakdownFile = data;
                this.filterBreakdownFile = data;
                this.breakdownFileSource.data = this.filterBreakdownFile;
                if (Utils.isAdminLacour(this.role))
                {
                    this.displayedColumns = this.displayedAdminLacour;
                    this.displayedColumnsDisconnectedScales = ["Unisite", "Nom_RS", "Adresse1", "Adresse2", "Code Postal", "Ville", "Pays", "Numserie", "Dateinstallation", "Fincontrat", "Programme", "Bdd Locale", "Bdd Internet", "Spectro"];
                }
                else if (Utils.isRT(this.role))
                    this.displayedColumns = this.displayedIxell;
            };
            if (this.filteredBreakdownFilesSub != null) this.filteredBreakdownFilesSub.unsubscribe();
        }, error => {
            if (this.filteredBreakdownFilesSub != null) this.filteredBreakdownFilesSub.unsubscribe();
        });
        this.country = this.storage.get("country")
        if (this.country) {
            this.Form.setValue({
                Country: this.countries.find((c: any) => c.name == this.country).name,
                PostalCode: '',
                SocialReason: '',
                CTC: '',
                DateStart: '',
                DateEnd: ''
            });
        }
    }

    ngOnDestroy() {
        if (this.BreakdownFileSub != null) this.BreakdownFileSub.unsubscribe();
        if (this.filteredBreakdownFilesSub != null) this.filteredBreakdownFilesSub.unsubscribe();
        if (this.addBreakdownFileSub != null) this.addBreakdownFileSub.unsubscribe();
        if (this.deleteBreakdownFileSub != null) this.deleteBreakdownFileSub.unsubscribe();
        if (this.editBreakdownFileSub != null) this.editBreakdownFileSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.scaleVersionSub != null) this.scaleVersionSub.unsubscribe();
        if (this.scaleVersionAssistanceSub != null) this.scaleVersionAssistanceSub.unsubscribe();
        if (this.exportSub != null) this.exportSub.unsubscribe();
        if (this.exportAssistSub != null) this.exportAssistSub.unsubscribe();
        if (this.disconnectedScaleVersionSub != null) this.disconnectedScaleVersionSub.unsubscribe();
        if (this.disconnectedTempScaleVersionSub != null) this.disconnectedTempScaleVersionSub.unsubscribe();
        if (this.ConnectedScaleVersionSub != null) this.ConnectedScaleVersionSub.unsubscribe();
        if (this.exportConnectSub != null) this.exportConnectSub.unsubscribe();
        if (this.exportNonConnectSub != null) this.exportNonConnectSub.unsubscribe();
        if (this.exportNonConnectTempSub != null) this.exportNonConnectTempSub.unsubscribe();
        if (this.getStatsSub != null) this.getStatsSub.unsubscribe();
        if (this.GetHorsContratSub != null) this.GetHorsContratSub.unsubscribe();
        if (this.getDateImportSub != null) this.getDateImportSub.unsubscribe();
    }

    //Datepicker filtre liste des Rapports d'activité
    chosenStartYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.startdate.value;
        ctrlValue.year(normalizedYear.year());
        this.startdate.setValue(ctrlValue);
    }

    chosenEndYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.enddate.value;
        ctrlValue.year(normalizedYear.year());
        this.enddate.setValue(ctrlValue);
    }

    chosenStartMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.startdate.value;
        ctrlValue.month(normalizedMonth.month());
        this.startdate.setValue(ctrlValue);
        datepicker.close();
    }

    chosenEndMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.enddate.value;
        ctrlValue.month(normalizedMonth.month());
        this.enddate.setValue(ctrlValue);
        //this.enddate.setValue(normalizedMonth.month() + "/" + normalizedMonth.year());
        if (this.enddate.value > this.startdate.value)
            datepicker.close();
    }

    changeFilter() {
        this.breakdownInterval.start = this.startdate.value;
        this.breakdownInterval.end = this.enddate.value;
        this.filterBreakdownFile = [];
        this.filteredBreakdownFilesSub = this.api.filteredBreakdownFiles(this.breakdownInterval).subscribe(data => {
            data.forEach(element => {
                element.fileDate.setHours(1);
                this.filterBreakdownFile.push(element);
            })
            this.sortFile(this.sortDefault, "1");
            this.sortDefault = { active: "dateFileEdit", direction: "desc" };
            this.breakdownFileSource.data = this.filterBreakdownFile;
            if (this.filteredBreakdownFilesSub != null) this.filteredBreakdownFilesSub.unsubscribe();
        }, error => {
            if (this.filteredBreakdownFilesSub != null) this.filteredBreakdownFilesSub.unsubscribe();
        });
    }

    //Datepicker changement date file
    chosenChangeYearHandler(normalizedYear: Moment, bdfile: IBreakdownFileV1, i: number) {
        let index = this.allBreakdownFile.findIndex(x => x.breakdownFileID == bdfile.breakdownFileID);
        this.allBreakdownFile[index].fileDate.setFullYear(normalizedYear.year());
    }

    chosenChangeMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, bdfile: IBreakdownFileV1, i: number) {
        this.allBreakdownFile[i].fileDate.setMonth(normalizedMonth.month());
        this.allBreakdownFile[i].fileDate.setDate(2);
        this.editBreakdownFileSub = this.api.editBreakdownFile(this.allBreakdownFile[i]).subscribe(data => {
            if (data) {
                this.allBreakdownFile[i].fileDate.setDate(1);
                this.breakdownFileSource.data[i].fileDate = new Date(this.allBreakdownFile[i].fileDate);
                this.changeFilter();
            }
            if (this.editBreakdownFileSub != null) this.editBreakdownFileSub.unsubscribe();
        }, error => {
            if (this.editBreakdownFileSub != null) this.editBreakdownFileSub.unsubscribe();
        });
        datepicker.close();
    }

    //Datepicker enregistrement Rapport d'activité
    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value;
        ctrlValue.month(normalizedMonth.month());
        this.date.setValue(ctrlValue);
        datepicker.close();
    }

    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.date.value;
        ctrlValue.year(normalizedYear.year());
        this.date.setValue(ctrlValue);
    }

    openModalAddFile() {
        this.BreakdownFile = new IBreakdownFileV1();
        this.displayModalAddFile = true;
    }

    closeModalAddFile() {
        this.displayModalAddFile = false;
    }

    onFileChanged(event: any) {
        this.selectedFile = event.target.files[0];
        let reader: FileReader = new FileReader();
        reader.onloadend = () => {
            var base64data = reader.result as string;
            this.BreakdownFile.breakdownFile = base64data.substr(base64data.indexOf(',') + 1);
            this.BreakdownFile.breakdownName = this.selectedFile.name;
        };
        reader.readAsDataURL(this.selectedFile);
    }

    addFile() {
        this.BreakdownFile.fileDate = new Date(this.date.value);
        this.BreakdownFile.fileDate.setDate(1);
        this.addBreakdownFileSub = this.api.addBreakdownFile(this.BreakdownFile).subscribe(data => {
            this.BreakdownFile.breakdownFileID = data;
            this.allBreakdownFile.push(this.BreakdownFile);
            this.changeFilter()
            this.displayModalAddFile = false;
            if (this.addBreakdownFileSub != null) this.addBreakdownFileSub.unsubscribe();
        }, error => {
            if (this.addBreakdownFileSub != null) this.addBreakdownFileSub.unsubscribe();
        });
    }

    chosenYearEditHandler(normalizedYear: Moment) {
        this.BreakdownFile.fileDate.setFullYear(normalizedYear.year());
    }

    chosenMonthEditHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        this.BreakdownFile.fileDate.setMonth(normalizedMonth.month());
        this.BreakdownFile.fileDate.setDate(2);
        this.BreakdownFile.fileDate = new Date(this.BreakdownFile.fileDate);
        datepicker.close();
    }

    openModalEditFile(bdf: IBreakdownFileV1) {
        this.BreakdownFile = bdf;
        this.idSuppr = bdf.breakdownFileID;
        this.displayModalEditFile = true;
    }

    closeModalEditFile() {
        this.displayModalEditFile = false;
    }

    editFile() {
        this.editBreakdownFileSub = this.api.editBreakdownFile(this.BreakdownFile).subscribe(data => {
            if (data) {
                this.changeFilter();
                this.displayModalEditFile = false;
            }
            if (this.editBreakdownFileSub != null) this.editBreakdownFileSub.unsubscribe();
        }, error => {
            if (this.editBreakdownFileSub != null) this.editBreakdownFileSub.unsubscribe();
        });
    }

    openModalDeleteFile(bdf: IBreakdownFileV1) {
        this.BreakdownFile = bdf;
        this.idSuppr = bdf.breakdownFileID;
        this.displayModalDeleteFile = true;
    }

    closeModalDeleteFile() {
        this.displayModalDeleteFile = false;
    }

    deleteFile() {
        this.deleteBreakdownFileSub = this.api.deleteBreakdownFile(this.idSuppr).subscribe(data => {
            if (data) {
                this.allBreakdownFile.splice(this.allBreakdownFile.findIndex(x => x.breakdownFileID == this.idSuppr), 1);
                this.changeFilter();
                this.displayModalDeleteFile = false;
            }
            if (this.deleteBreakdownFileSub != null) this.deleteBreakdownFileSub.unsubscribe();
        }, error => {
            if (this.deleteBreakdownFileSub != null) this.deleteBreakdownFileSub.unsubscribe();
        });
    }

    openFile(bdf: IBreakdownFileV1) {
        this.BreakdownFileSub = this.api.breakdownFile(bdf.breakdownFileID).subscribe(data => {
            Utils.openBase64Content("data:application/pdf;base64," + data.breakdownFile, data.breakdownName);
            if (this.BreakdownFileSub != null) this.BreakdownFileSub.unsubscribe();
        }, error => {
            if (this.BreakdownFileSub != null) this.BreakdownFileSub.unsubscribe();
        });
    }

    sortFile(sort: Sort, status: string) {
        var data = this.filterBreakdownFile;
        Constants.sortScale(sort, status, data)

        this.filterBreakdownFile = data.slice();
        this.breakdownFileSource = new MatTableDataSource(this.filterBreakdownFile);
    }

    sortAssist(sort: Sort, status: string) {
        var data = this.sendScalesAssistance;
        Constants.sortScale(sort, status, data)

        this.sendScalesAssistance = data.slice();
        this.AssistanceSource = new MatTableDataSource(this.sendScalesAssistance);
    }

    sortVersionConnected(sort: Sort, status: string) {
        var data = this.connectedScales;
        Constants.sortScale(sort, status, data)

        this.connectedScales = data.slice();
        this.ScalesConnectedSource = new MatTableDataSource(this.connectedScales);
    }

    sortVersionDisconnected(sort: Sort, status: string) {
        var data = this.disconnectedScales;
        Constants.sortScale(sort, status, data)

        this.disconnectedScales = data.slice();
        this.ScalesDisconnectedSource = new MatTableDataSource(this.disconnectedScales);
    }

    sortVersionDisconnectedTemp(sort: Sort, status: string) {
        var data = this.disconnectedTempScales;
        Constants.sortScale(sort, status, data)

        this.disconnectedTempScales = data.slice();
        this.ScalesDisconnectedTempSource = new MatTableDataSource(this.disconnectedTempScales);
    }

    sortVersionHorsContrat(sort: Sort, status: string) {
        var data = this.horsContratScales;
        Constants.sortScale(sort, status, data)

        this.horsContratScales = data.slice()
        this.ScalesHorsContratSource = new MatTableDataSource(this.horsContratScales);
    }

    Export() {

        this.isLoading = true;

        this.exportSub = this.api.exportScalesVersion().subscribe(data => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(data.data);
            element.download = "Fichier MAJ Ixell";
            document.body.appendChild(element);
            element.click();

            this.isLoading = false;

        }, error => {
            if (this.exportSub != null) this.exportSub.unsubscribe();
            this.isLoading = false;
        });
    }


    ExportAssistance() {

        this.isLoading = true;

        this.exportAssistSub = this.api.exportScalesAssistance(this.Form.value.Country, this.Form.value.PostalCode, this.Form.value.SocialReason, this.Form.value.CTC, this.Form.value.DateStart._d != "" ? this.Form.value.DateStart._d : undefined, this.Form.value.DateEnd._d != "" ? this.Form.value.DateEnd._d : undefined).subscribe(data => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(data.data);
            element.download = "Fichier MAJ Ixell";
            document.body.appendChild(element);
            element.click();

            this.isLoading = false;

        }, error => {
            if (this.exportAssistSub != null) this.exportAssistSub.unsubscribe();
            this.isLoading = false;
        });
    }

    ExportConnecte() {

        this.isLoading = true;

        this.exportConnectSub = this.api.exportScalesVersionDetails(1).subscribe(data => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(data.data);
            element.download = "Balances connectees Ixell";
            document.body.appendChild(element);
            element.click();

            this.isLoading = false;

        }, error => {
            if (this.exportConnectSub != null) this.exportConnectSub.unsubscribe();
            this.isLoading = false;
        });
    }

    ExportNonConnecte() {

        this.isLoading = true;

        this.exportNonConnectSub = this.api.exportScalesVersionDetails(2).subscribe(data => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(data.data);
            element.download = "Balances non connectees Ixell";
            document.body.appendChild(element);
            element.click();

            this.isLoading = false;

        }, error => {
            if (this.exportNonConnectSub != null) this.exportNonConnectSub.unsubscribe();
            this.isLoading = false;
        });
    }

    ExportNonConnecteTemp() {

        this.isLoading = true;

        this.exportNonConnectTempSub = this.api.exportScalesVersionDetails(3).subscribe(data => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(data.data);
            element.download = "Balances non connectees temp Ixell";
            document.body.appendChild(element);
            element.click();

            this.isLoading = false;

        }, error => {
            if (this.exportNonConnectTempSub != null) this.exportNonConnectTempSub.unsubscribe();
            this.isLoading = false;
        });
    }

    ExportHorsContrat() {

        this.isLoading = true;

        this.exportNonConnectTempSub = this.api.exportScalesVersionDetails(4).subscribe(data => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(data.data);
            element.download = "Balances hors contrat Ixell";
            document.body.appendChild(element);
            element.click();

            this.isLoading = false;

        }, error => {
            if (this.exportNonConnectTempSub != null) this.exportNonConnectTempSub.unsubscribe();
            this.isLoading = false;
        });
    }

    changeVersion(tabgroup: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log(tabgroup);
        if (tabgroup.selectedIndex != 4)
            this.currentTabGroup = tabgroup.selectedIndex;
        else {
            tabgroup.selectedIndex = this.currentTabGroup;
            /* position de l'index dans la liste (ce n'est pas la valeur associer au type de connexion) */
            switch (this.currentTabGroup) {
                case 0:
                    this.Export()
                    break;
                case 1:
                    this.ExportConnecte()
                    break;
                case 2:
                    this.ExportNonConnecteTemp()
                    break;
                case 3:
                    this.ExportNonConnecte()
                    break;
                //case 4:
                //  this.ExportHorsContrat();
                //  break;
            }
        }
    }

    LoadData(tabgroup: any) {
        if (tabgroup.selectedIndex == 1) {
            if (this.sendScales.length == 0) {
                this.scaleVersionSub = this.api.getScalesVersion().subscribe(data => {
                    this.sendScales = data;
                    this.sendScales.forEach(x => {
                        this.dateImportationVersion = x.dateImportation;
                        //bddLocal
                        x.stats.bddLocal.forEach(y => {
                            if (y.version == "") {
                                y.version = " ";
                            }
                            if (this.versionsLocal.indexOf(y.version) < 0)
                                this.versionsLocal.push(y.version);
                        });
                        //bddinternet
                        x.stats.bddInternet.forEach(y => {
                            if (y.version == "") {
                                y.version = " ";
                            }
                            if (this.versionsInternet.indexOf(y.version) < 0)
                                this.versionsInternet.push(y.version);
                        });
                        //bddinternet
                        x.stats.majSpectro.forEach(y => {
                            if (y.version == "") {
                                y.version = " ";
                            }
                            if (y.version.indexOf("WinIxell") >= 0) {
                                if (this.versionsSpectroWinIxell.indexOf(y.version.substr(9)) < 0)
                                    this.versionsSpectroWinIxell.push(y.version.substr(9));
                            }
                            else
                                if (y.version.indexOf("IxellTech") >= 0) {
                                    y.version = y.version.replace("Spectro IxellTech - ", "");
                                    if (this.versionsSpectroIxellTech.indexOf(y.version.replace("Spectro IxellTech - ", "")) < 0)
                                        this.versionsSpectroIxellTech.push(y.version.replace("Spectro IxellTech - ", ""));
                                }
                                else
                                    if (this.versionsSpectro.indexOf(y.version) < 0)
                                        this.versionsSpectro.push(y.version);
                        });
                    });

                    this.BddLocalSource = new MatTableDataSource(this.sendScales);
                    this.versionsLocal.sort((a, b) => {
                        if (a.substr(1) == b.substr(1)) {
                            if (a[0] > b[0]) return -1;
                            if (b[0] > a[0]) return 1;
                        }
                        if (a.substr(1) > b.substr(1)) return -1;
                        if (a.substr(1) < b.substr(1)) return 1;
                    });
                    this.versionsLocal.forEach(x => {
                        if (x != null)
                            this.displayedColumnsBDDLocal.push(x)
                    });
                    this.versionsInternet.sort((a, b) => {
                        let tmpa;
                        let tmpb;
                        if (a == null)
                            return -1
                        if (b == null)
                            return 1;

                        if (a.indexOf("-") > -1) {
                            tmpa = a.split("-");
                            tmpb = b.split("-");
                        }
                        else {
                            if (a.indexOf("/") > -1) {
                                tmpa = a.split("/");
                                tmpb = b.split("/");
                            }
                        }
                        if (tmpa[1] == tmpb[1]) {
                            if (Number.parseInt(tmpa[0]) > Number.parseInt(tmpb[0])) return -1;
                            if (Number.parseInt(tmpb[0]) > Number.parseInt(tmpa[0])) return 1
                            else return 0;
                        }
                        if (tmpa[1] > tmpb[1]) return -1
                        if (tmpb[1] > tmpa[1]) return 1
                    });
                    this.versionsInternet.forEach(x => {
                        if (x != null)
                            this.displayedColumnsBDDInternet.push(x)
                    });

                    this.versionsSpectro.sort((a, b) => {
                        let tmpa = a.split(" ");
                        let tmpb = b.split(" ");
                        if (tmpa[0] > tmpb[0]) return -1;
                        if (tmpa[0] < tmpb[0]) return 1;
                        if (tmpa[0] == tmpb[0]) {
                            let datea = tmpa[1].split("-")
                            let dateb = tmpb[1].split("-")
                            if (new Date("20" + datea[2] + "-" + datea[1] + "-" + datea[0]).getTime() > new Date("20" + dateb[2] + "-" + dateb[1] + "-" + dateb[0]).getTime()) return -1;
                            if (new Date("20" + datea[2] + "-" + datea[1] + "-" + datea[0]).getTime() < new Date("20" + dateb[2] + "-" + dateb[1] + "-" + dateb[0]).getTime()) return 1;
                        }
                    });
                    this.versionsSpectro.forEach(x => {
                        if (x != null)
                            this.displayedColumnsSpectro.push(x)
                    });

                    this.versionsSpectroIxellTech.sort((a, b) => {
                        if (a.substr(1) == b.substr(1)) {
                            if (a[0] > b[0]) return -1;
                            if (b[0] > a[0]) return 1;
                        }
                        if (a.substr(1) > b.substr(1)) return -1;
                        if (a.substr(1) < b.substr(1)) return 1;
                    });
                    this.versionsSpectroIxellTech.forEach(x => {
                        if (x != null) {
                            this.displayedColumnsSpectro.push(x); this.versionsSpectro.push(x);
                        }
                    });

                    this.versionsSpectroWinIxell.sort((a, b) => {
                        if (a.substr(1) == b.substr(1)) {
                            if (a[0] > b[0]) return -1;
                            if (b[0] > a[0]) return 1;
                        }
                        if (a.substr(1) > b.substr(1)) return -1;
                        if (a.substr(1) < b.substr(1)) return 1;
                    });
                    this.versionsSpectroWinIxell.forEach(x => {
                        if (x != null)
                            this.displayedColumnsSpectroWinIxell.push(x)
                    });

                    this.bddLocal = true;
                    this.bddInternet = true;
                    this.spectro = true;

                    this.ConnectedScaleVersionSub = this.api.getConnectedScalesVersion().subscribe(data => {
                        this.connectedScales = data.scale;
                        this.ScalesConnectedSource = new MatTableDataSource(this.connectedScales);
                    }, error => {
                        if (this.ConnectedScaleVersionSub != null) this.ConnectedScaleVersionSub.unsubscribe();
                    });

                    this.disconnectedScaleVersionSub = this.api.getDisconnectedScalesVersion().subscribe(data => {
                        this.disconnectedScales = data.scale;
                        this.ScalesDisconnectedSource = new MatTableDataSource(this.disconnectedScales);
                    }, error => {
                        if (this.disconnectedScaleVersionSub != null) this.disconnectedScaleVersionSub.unsubscribe();
                    });

                    this.disconnectedTempScaleVersionSub = this.api.getDisconnectedTempScalesVersion().subscribe(data => {
                        this.disconnectedTempScales = data.scale;
                        this.ScalesDisconnectedTempSource = new MatTableDataSource(this.disconnectedTempScales);
                    }, error => {
                        if (this.disconnectedTempScaleVersionSub != null) this.disconnectedTempScaleVersionSub.unsubscribe();
                    });

                    this.GetHorsContratSub = this.api.getHorsContratScalesVersion().subscribe(data => {
                        this.horsContratScales = data.scale;
                        this.ScalesHorsContratSource = new MatTableDataSource(data.scale);
                    }, error => {
                        if (this.GetHorsContratSub != null) this.GetHorsContratSub.unsubscribe();
                    })

                }, error => {
                    if (this.scaleVersionSub != null) this.scaleVersionSub.unsubscribe();
                });
            }
        }
        else {
            if (tabgroup.selectedIndex == 2) {
                this.getDateImportSub = this.api.getDateImportationBalances().subscribe(data => {
                    this.dateImportationAssistance = data[1];
                },
                    error => {
                        if (this.getDateImportSub != null) this.getDateImportSub.unsubscribe();
                    })
                //if (this.AllsendScalesAssistance.length == 0) {
                //  this.scaleVersionAssistanceSub = this.api.getScalesAssistance(null, null, null, null, null, null).subscribe(data => {
                //    this.AllsendScalesAssistance = data.send_Balance_Assistance;
                //    data.send_Balance_Assistance.forEach(x => {
                //      if (Number.parseInt(x.tempsPriseEncharge) < 1800)
                //        this.min30 += 1;
                //      else
                //        if (Number.parseInt(x.tempsPriseEncharge) < 3600)
                //          this.min1 += 1;
                //        else
                //          if (Number.parseInt(x.tempsPriseEncharge) < 7200)
                //            this.min2 += 1;
                //          else
                //            this.plus2 += 1;
                //    });
                //    let total: number = this.min30 + this.min1 + this.min2 + this.plus2;
                //    this.min30 = this.min30 / total * 100;
                //    this.min1 = this.min1 / total * 100;
                //    this.min2 = this.min2 / total * 100;
                //    this.plus2 = this.plus2 / total * 100;
                //    let minDuree: number = Math.floor(data.dureeAppelMoyen / 60);
                //    let secondsDuree: number = data.dureeAppelMoyen % 60;
                //    this.dureeAppelMoy = minDuree > 0 ? minDuree.toString() + "min " : "";
                //    this.dureeAppelMoy += secondsDuree > 0 ? secondsDuree.toString() + "s" : "";
                //    this.nbDossier = data.nbDossier / 12;
                //  }, error => {
                //    if (this.scaleVersionAssistanceSub != null) this.scaleVersionAssistanceSub.unsubscribe();
                //  });
                //}
            }
            else {
                if (tabgroup.selectedIndex == 3) {
                    this.getStats();
                }
            }
        }
    }

    GetNbLocal(country: string, version: string) {
        let stats: Stats = this.sendScales.find(x => x.country == country).stats.bddLocal.find(y => y.version == version);
        if (stats)
            return stats.nb;
        else
            return 0;
    }

    GetNbInternet(country: string, version: string) {
        let stats: Stats = this.sendScales.find(x => x.country == country).stats.bddInternet.find(y => y.version == version);
        if (stats)
            return stats.nb;
        else
            return 0;
    }

    GetNbSpectro(country: string, version: string) {
        let stats: Stats = this.sendScales.find(x => x.country == country).stats.majSpectro.find(y => y.version == version);
        if (stats)
            return stats.nb;
        else
            return 0;
    }

    GetNbSpectroWinIxell(country: string, version: string) {
        let stats: Stats = this.sendScales.find(x => x.country == country).stats.majSpectro.find(y => y.version == "WinIxell " + version);
        if (stats)
            return stats.nb;
        else
            return 0;
    }

    GetTotalLocal(version: string) {
        let nb: number = 0
        this.sendScales.forEach(s => s.stats.bddLocal.forEach(y => { if (y.version == version) nb += y.nb }));
        return nb;
    }

    GetTotalInternet(version: string) {
        let nb: number = 0
        this.sendScales.forEach(s => s.stats.bddInternet.forEach(y => { if (y.version == version) nb += y.nb }));
        return nb;
    }

    GetTotalSpectro(version: string) {
        let nb: number = 0
        this.sendScales.forEach(s => s.stats.majSpectro.forEach(y => { if (y.version == version) nb += y.nb }));
        return nb;
    }

    GetTotalSpectroWinIxell(version: string) {
        let nb: number = 0
        this.sendScales.forEach(s => s.stats.majSpectro.forEach(y => { if (y.version == "WinIxell " + version) nb += y.nb }));
        return nb;
    }

    OpenMAJLocal() {
        this.localOpen = !this.localOpen;
    }

    OpenMAJInternet() {
        this.internetOpen = !this.internetOpen;
    }

    OpenMAJSpectro() {
        this.spectroOpen = !this.spectroOpen;
    }

    getStats() {
        this.getStatsSub = this.api.getStatsAssitance().subscribe(data => {
            this.statsDateDeb = data[6];
            this.statsDateFin = data[7];
            this.nbDossier = Number.parseFloat(data[0]) / 12;
            this.min30 = Number.parseFloat(data[1]);
            this.min1 = Number.parseFloat(data[2]);
            this.min2 = Number.parseFloat(data[3]);
            this.plus2 = Number.parseFloat(data[4]);
            let minDuree: number = Math.floor(Number.parseFloat(data[5]) / 60);
            let secondsDuree: number = Number.parseFloat(data[5]) % 60;
            this.dureeAppelMoy = minDuree > 0 ? minDuree.toString() + "min " : "";
            this.dureeAppelMoy += secondsDuree > 0 ? Math.floor(secondsDuree).toString() + "s" : "";
        }, error => {
            if (this.getStatsSub != null) this.getStatsSub.unsubscribe();
        })
    }

    filtreAssistance() {
        this.currentAssistance = null
        this.sendScalesAssistance = [];
        this.scaleVersionAssistanceSub = this.api.getScalesAssistance(this.Form.value.Country, this.Form.value.PostalCode, this.Form.value.SocialReason, this.Form.value.CTC, this.Form.value.DateStart ? this.Form.value.DateStart._d : undefined, this.Form.value.DateEnd ? this.Form.value.DateEnd._d : undefined).subscribe(data => {
            this.AllsendScalesAssistance = data.send_Balance_Assistance;
            this.dateImportationAssistance = data.dateImportation;
            //data.send_Balance_Assistance.forEach(x => {
            //  if (Number.parseInt(x.tempsPriseEncharge) < 1800)
            //    this.min30 += 1;
            //  else
            //    if (Number.parseInt(x.tempsPriseEncharge) < 3600)
            //      this.min1 += 1;
            //    else
            //      if (Number.parseInt(x.tempsPriseEncharge) < 7200)
            //        this.min2 += 1;
            //      else
            //        this.plus2 += 1;
            //});
            //let total: number = this.min30 + this.min1 + this.min2 + this.plus2;
            //this.min30 = this.min30 / total * 100;
            //this.min1 = this.min1 / total * 100;
            //this.min2 = this.min2 / total * 100;
            //this.plus2 = this.plus2 / total * 100;
            let minDuree: number = Math.floor(data.dureeAppelMoyen / 60);
            let secondsDuree: number = data.dureeAppelMoyen % 60;
            this.dureeAppelMoy = minDuree > 0 ? minDuree.toString() + "min " : "";
            this.dureeAppelMoy += secondsDuree > 0 ? secondsDuree.toString() + "s" : "";
            this.nbDossier = data.nbDossier / 12;
            this.AllsendScalesAssistance.forEach(x => {
                if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
                    this.sendScalesAssistance.push(x);
            });
            this.AssistanceSource = new MatTableDataSource(this.sendScalesAssistance);
        }, error => {
            if (this.scaleVersionAssistanceSub != null) this.scaleVersionAssistanceSub.unsubscribe();
        });

        //this.currentAssistance = null
        //this.sendScalesAssistance = [];
        //this.AllsendScalesAssistance.forEach(x => {
        //  if (x.pays && x.pays.toLowerCase() == this.Form.value.Country.toLowerCase()) {
        //    if (this.Form.value.PostalCode != "") {
        //      if (x.code_Postal.startsWith(this.Form.value.PostalCode)) {
        //        if (this.Form.value.SocialReason != "") {
        //          if (x.raison_sociale.toLowerCase().indexOf(this.Form.value.SocialReason.toLowerCase()) > -1) {
        //            if (this.Form.value.CTC != "") {
        //              if (x.ctc && x.ctc.toLowerCase().indexOf(this.Form.value.CTC.toLowerCase()) >= 0) {
        //                if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //                  if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //                    if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                      this.sendScalesAssistance.push(x);
        //                }
        //                else
        //                  if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                    this.sendScalesAssistance.push(x);
        //              }
        //            }
        //            else {
        //              if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //                if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //                  if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                    this.sendScalesAssistance.push(x);
        //              }
        //              else
        //                if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                  this.sendScalesAssistance.push(x);
        //            }
        //          }
        //        }
        //        else {
        //          if (this.Form.value.CTC != "") {
        //            if (x.ctc && x.ctc.toLowerCase().indexOf(this.Form.value.CTC.toLowerCase()) >= 0) {
        //              if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //                if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //                  if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                    this.sendScalesAssistance.push(x);
        //              }
        //              else
        //                if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                  this.sendScalesAssistance.push(x);
        //            }
        //          }
        //          else {
        //            if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //              if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //                if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                  this.sendScalesAssistance.push(x);
        //            }
        //            else
        //              if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                this.sendScalesAssistance.push(x);
        //          }
        //        }
        //      }
        //    }
        //    else {
        //      if (this.Form.value.SocialReason != "") {
        //        if (x.raison_sociale.toLowerCase().indexOf(this.Form.value.SocialReason.toLowerCase()) > -1) {
        //          if (this.Form.value.CTC != "") {
        //            if (x.ctc && x.ctc.toLowerCase().indexOf(this.Form.value.CTC.toLowerCase()) >= 0) {
        //              if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //                if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //                  if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                    this.sendScalesAssistance.push(x);
        //              }
        //              else
        //                if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                  this.sendScalesAssistance.push(x);
        //            }
        //          }
        //          else {
        //            if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //              if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //                if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                  this.sendScalesAssistance.push(x);
        //            }
        //            else
        //              if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                this.sendScalesAssistance.push(x);
        //          }
        //        }
        //      }
        //      else {
        //        if (this.Form.value.CTC != "") {
        //          if (x.ctc && x.ctc.toLowerCase().indexOf(this.Form.value.CTC.toLowerCase()) >= 0) {
        //            if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //              if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //                if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                  this.sendScalesAssistance.push(x);
        //            }
        //            else
        //              if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                this.sendScalesAssistance.push(x);
        //          }
        //        }
        //        else {
        //          if (this.Form.value.DateStart != "" && this.Form.value.DateEnd != "") {
        //            if (new Date(x.date_creation).getTime() > this.Form.value.DateStart._d.getTime() && new Date(x.date_de_cloture).getTime() < this.Form.value.DateEnd._d.getTime())
        //              if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //                this.sendScalesAssistance.push(x);
        //          }
        //          else
        //            if (this.sendScalesAssistance.find(y => y.code_Client == x.code_Client) == null)
        //              this.sendScalesAssistance.push(x);
        //        }
        //      }
        //    }
        //  }
        //});

        //this.AssistanceSource = new MatTableDataSource(this.sendScalesAssistance);
    }

    openAssistance(assist: IScaleAssistance) {
        let info: IScaleAssistance[] = [];
        this.AllsendScalesAssistance.forEach(x => {
            if (x.code_Client == assist.code_Client) {
                info.push(x);
            }
        });
        info.sort((a, b) => {
            if (a == null) return -1;
            return (new Date(a.message_Date_creation).getTime() < new Date(b.message_Date_creation).getTime() ? -1 : 1) * (-1);
        });
        this.currentRS = assist.raison_sociale;
        this.assistanceDos = true;
        this.AssistanceSource = new MatTableDataSource(null);
        this.AssistanceInfoSource = new MatTableDataSource(null);
        this.AssistanceDosSource = new MatTableDataSource(info);

        if (info.length == 1)
            this.SelectDosAssistance(assist);
    }

    SelectDosAssistance(assist: IScaleAssistance) {
        if (assist.date_de_cloture == "0000-00-00T00:00:00")
            assist.date_de_cloture = "";
        if (!assist.tempsPriseEnchargeCalc) {
            if (Number.parseInt(assist.tempsPriseEncharge) < 120)
                assist.tempsPriseEnchargeCalc = "immédiat";
            else {
                let minTemps: number = Math.floor(Number.parseInt(assist.tempsPriseEncharge, 10) / 60);
                let secondsTemps: number = Number.parseInt(assist.tempsPriseEncharge) % 60;
                assist.tempsPriseEnchargeCalc = minTemps > 0 ? minTemps.toString() + "min " : "";
                assist.tempsPriseEnchargeCalc += secondsTemps > 0 ? secondsTemps.toString() + "s" : "";
            }
        }
        this.currentAssistanceTotalCallTime = 0;
        if (assist.appel) {
            assist.appel.forEach(a => {
                if (a.heuredebutAppel.indexOf('.') >= 0)
                    a.heuredebutAppel = a.heuredebutAppel.substring(0, a.heuredebutAppel.indexOf('.'));
                this.currentAssistanceTotalCallTime += Number.parseInt(a.dureeAppel, 10);
                if (!a.dureeAppelCalc) {
                    let hDuree: number = Math.trunc(Math.floor(Number.parseInt(a.dureeAppel, 10) / 60) / 60);
                    let minDuree: number = Math.trunc((Math.floor(Number.parseInt(a.dureeAppel, 10) / 60) / 60 - hDuree) * 60);
                    let secondsDuree: number = Number.parseInt(a.dureeAppel) % 60;
                    a.dureeAppelCalc = hDuree > 0 ? hDuree.toString() + "h " : "";
                    a.dureeAppelCalc += minDuree > 0 ? minDuree.toString() + "min " : "";
                    a.dureeAppelCalc += secondsDuree > 0 ? secondsDuree.toString() + "s" : "";
                }
            });
        }
        let heureDureeTotal: number = Math.trunc(Math.floor(this.currentAssistanceTotalCallTime / 60) / 60);
        let minDureeTotal: number = Math.trunc((Math.floor(this.currentAssistanceTotalCallTime / 60) / 60 - heureDureeTotal) * 60);
        let secondsDureeTotal: number = this.currentAssistanceTotalCallTime % 60;
        this.currentAssistanceTotalCallTimeCalc = heureDureeTotal > 0 ? heureDureeTotal.toString() + "h " : "";
        this.currentAssistanceTotalCallTimeCalc += minDureeTotal > 0 ? minDureeTotal.toString() + "min " : "";
        this.currentAssistanceTotalCallTimeCalc += secondsDureeTotal > 0 ? secondsDureeTotal.toString() + "s" : "";

        let info: IScaleAssistance[] = [];
        info.push(assist);

        this.AssistanceInfoSource = new MatTableDataSource(info[0].appel);
        this.AssistanceSource = new MatTableDataSource(info);
        this.currentAssistance = assist;
    }

    closeInfo() {
        this.currentAssistanceTotalCallTime = 0;
        this.currentAssistanceTotalCallTimeCalc = "";
        this.currentAssistance = null;
        this.assistanceDos = false;
        if (this.sendScalesAssistance.length > 0)
            this.AssistanceSource = new MatTableDataSource(this.sendScalesAssistance);
        else
            this.AssistanceSource = new MatTableDataSource(this.AllsendScalesAssistance);
    }
}
